// extracted by mini-css-extract-plugin
module.exports = {"accounts":"accounts_settings_accounts__240bw","searchBar":"accounts_settings_searchBar__13dN9"};